const columns = () => {
  return [
    {
      title: "知识类型",
      name: "title",
      dataIndex: "title",
      searchItem: {},
      tableItem: {
        width: 100
      }
    },
    {
      title: "内容形式",
      name: "contentType",
      dataIndex: "contentType",
      dict: [
        { code: 1, codeName: '文件上传' },
        { code: 2, codeName: '富文本框' },
      ],
      searchItem: {
        type: 'select'
      },
    },
    {
      title: "内容形式",
      name: "contentTypeStr",
      dataIndex: "contentTypeStr",
      tableItem: {
        width: 100
      },
    },
    {
      title: "支持文件格式",
      name: "fileType",
      dataIndex: "fileType",
      dict: [
        { code: 1, codeName: 'PDF' },
        { code: 2, codeName: 'DOC' },
        { code: 3, codeName: 'DOCX' },
        { code: 4, codeName: 'XLS' },
        { code: 5, codeName: 'XLSX' },
        { code: 6, codeName: 'PPT' },
        { code: 7, codeName: 'PPTX' },
        { code: 8, codeName: 'MP4' },
        { code: 9, codeName: 'MOV' },
        { code: 10, codeName: 'RM' },
        { code: 11, codeName: 'MPG' },
        { code: 12, codeName: 'AVI' },
      ],
      searchItem: {
        type: 'select'
      },
    },
    {
      title: "支持文件格式",
      name: "fileTypeStr",
      dataIndex: "fileTypeStr",
      tableItem: {
        width:300,
      },
    },
    {
      title: "前端列表",
      name: "displayType",
      dataIndex: "displayType",
      tableItem: {
        width:200,
      },
      dict: [
        { code: 1, codeName: '文字列表' },
        { code: 2, codeName: '图文列表(左图右文)' },
        { code: 3, codeName: '图文列表(上图下文)' }
      ],
      searchItem: {
        type: 'select'
      },
    },
    {
      title: "备注",
      name: "mark",
      dataIndex: "mark",
      tableItem: {
        width:150,
      }
    },
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      tableItem: {
        width:100,
      },
      dict: [
        { code: 1, codeName: '启用' },
        { code: 0, codeName: '禁用' }
      ],
      searchItem: {
        type: 'select'
      },
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'proKnowledgeType/pageList',
    ...api
  }
}

const proKnowledgeType = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'title',
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default proKnowledgeType
